import React, { useState } from "react";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import { CARD_STYLE } from "../../../constants/styles";
import QuestionnaireModeSelector from "../QuestionnaireModeSelector";
import { useHistory } from "react-router-dom";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../constants/styles";

export default function QuestionnaireConfiguration() {

  const history = useHistory();

  const [filters, setFilters] = useState({
    name: "",
    status: ""
  });

  const dummyQuestionnaires = [
    { id: 1, name: "Workplace Utilisation Survey", status: "Active", frequency: "Quarterly", lastIssued: "10 Jan 2026" },
    { id: 2, name: "Health & Safety Feedback", status: "Draft", frequency: "Monthly", lastIssued: "-" },
    { id: 3, name: "Moves & Strategy 2025", status: "Archived", frequency: "Annual", lastIssued: "2024" }
  ];

  const cardHeader = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "13px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "10px",
	padding:"20px"
  };

  const labelStyle = {
    fontSize: "12px",
    color: "#666",
    marginBottom: "4px",
	marginLeft:"20px"
  };

  const inputStyle = {
    padding: "6px 8px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "12px",
	marginLeft:"20px",
	width:"300px"
  };

  const buttonStyle = {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600"
  };

  const goEdit = (id) => {
    history.push(`/workflow/configuration/edit/${id}`);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", width: "calc(100% - 60px)", marginLeft: "60px", marginTop: "60px" }}>
        <Header />
        <LeftMenu />

        {/* SEARCH CARD */}
        <div style={{ ...CARD_STYLE, margin: "30px", flexDirection: "column", paddingBottom:'20px', background: GREY_GRADIENT_PANEL_BACKGROUND }}>
          <div style={cardHeader}>Search Questionnaires</div>

          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={labelStyle}>Name</div>
              <input
                style={inputStyle}
                placeholder="Questionnaire name"
                value={filters.name}
                onChange={(e) => setFilters({ ...filters, name: e.target.value })}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={labelStyle}>Status</div>
              <select
                style={inputStyle}
                value={filters.status}
                onChange={(e) => setFilters({ ...filters, status: e.target.value })}
              >
                <option value="">All</option>
                <option value="Active">Active</option>
                <option value="Draft">Draft</option>
                <option value="Archived">Archived</option>
              </select>
            </div>

            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <button style={buttonStyle}>Search</button>
            </div>

            <div style={{ display: "flex", alignItems: "flex-end", marginLeft: "auto", marginRight:'20px' }}>
              <button style={buttonStyle}>+ New Questionnaire</button>
            </div>
          </div>
        </div>

        {/* QUESTIONNAIRE LIST */}
        <div style={{ ...CARD_STYLE, margin: "0 30px 30px 30px", flexDirection: "column", background:ADMIN_PANEL_BACKGROUND_COLOR }}>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
            <thead style={{ height:'40px', background: GREY_GRADIENT_PANEL_BACKGROUND, borderBottom:'1px solid #000'}}>
              <tr style={{ textAlign: "left", color: "#666" }}>
                <th style={{ padding: "8px" }}>Name</th>
                <th style={{ padding: "8px" }}>Status</th>
                <th style={{ padding: "8px" }}>Frequency</th>
                <th style={{ padding: "8px" }}>Last Issued</th>
                <th style={{ padding: "8px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dummyQuestionnaires.map(q => (
                <tr key={q.id} style={{ borderTop: "1px solid #eee" }}>
                  <td style={{ padding: "8px" }}>{q.name}</td>
                  <td style={{ padding: "8px" }}>{q.status}</td>
                  <td style={{ padding: "8px" }}>{q.frequency}</td>
                  <td style={{ padding: "8px" }}>{q.lastIssued}</td>
                  <td style={{ padding: "8px" }}>
                    <button style={buttonStyle} onClick={() => goEdit(q.id)}>Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>

      <QuestionnaireModeSelector displayFlag="flex" />
    </>
  );
}
